// The header components read the school logo from `promo.thumbnailUri` / `promo.fileUri`
// (the old GraphQL `Asset` shape), so expose the new API's `logoUrl` through that shape.
export const mapSchoolLogoToPromo = (logoUrl?: string | null) =>
  logoUrl
    ? {
        id: logoUrl,
        fileUri: logoUrl,
        thumbnailUri: logoUrl,
        __typename: 'Asset',
      }
    : null;
